module.exports = __webpack_public_path__ + "assets/img/1_614.96de48b4.jpg";